import { combineReducers } from 'redux';

import creditcardReducer from './creditcard/creditcardReducer';
import invoice from './invoice/invoiceReducer';
import paypal from './paypal/paypalReducer';
import payment from './payment/paymentReducer';

export default combineReducers({
	creditcard: creditcardReducer,
	invoice,
	paypal,
	payment,
});
